import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useApi from '../hooks/useApi';
import GreenSheet from '../components/GreenSheet';

const CaseHistoryPrint = () => {
  const { caseType, caseId } = useParams();
  const { get } = useApi();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchHistory();
  }, [caseId, caseType]);

  const fetchHistory = async () => {
    try {
      setLoading(true);
      const response = await get(`/movements/${caseType}/${caseId}`);
      if (response && response.success) {
        setHistory(response.data);
      }
    } catch (err) {
      console.error('Failed to fetch history:', err);
      setError('Failed to load history');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="text-center py-4 text-gray-500">Loading history...</div>;
  if (error) return <div className="text-center py-4 text-red-500">{error}</div>;

  return (
    <div className="bg-white min-h-screen p-8 print:p-0">
      <div className="max-w-4xl mx-auto print:max-w-none print:mx-0">
        <div className="flex justify-between items-center mb-6 print:hidden">
          <h1 className="text-2xl font-bold text-gray-800">Print Preview</h1>
          <button 
            onClick={() => window.print()} 
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          >
            Print Green Sheet
          </button>
        </div>
        
        <GreenSheet history={history} title={`Green Sheet - ${caseType.toUpperCase()} #${caseId}`} />
      </div>
    </div>
  );
};

export default CaseHistoryPrint;
